import React from 'react';
import { PageLayout } from '@/shared/layout';
import { Card, FeaturePlaceholder, KPICard } from '@/components/ui';

export default function WorkloadForecastPage() {
  return (
    <PageLayout
      title="Dự báo Workload (Forecast)"
      description="Dự báo nhu cầu nhân công, thiết bị và vật tư trong 6-12 tháng tới dựa trên kế hoạch bảo dưỡng."
      breadcrumbs={[{ label: 'Workload', path: '/maintenance/workload' }, { label: 'Dự báo' }]}
    >
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <KPICard title="Đỉnh tải dự kiến" value="Tháng 07/2026" icon="ri-line-chart-line" variant="danger" />
          <KPICard title="Tổng giờ công 6T" value="12,450h" icon="ri-user-settings-line" variant="info" />
          <KPICard title="Ngân sách vật tư 6T" value="850.000.000đ" icon="ri-money-dollar-circle-line" variant="success" />
        </div>

        <Card className="p-20 flex items-center justify-center border-none shadow-sm min-h-[400px]">
          <FeaturePlaceholder 
            title="Biểu đồ dự báo Workload" 
            description="Tính năng phân tích xu hướng và dự báo tài nguyên đang được phát triển để giúp bạn chủ động hơn trong việc điều động tổ đội và mua sắm vật tư."
          />
        </Card>
      </div>
    </PageLayout>
  );
}
